import React, { useContext, useEffect, useState } from 'react'
import { FaHome, FaPhoneAlt, FaSignInAlt, FaUser, FaUserCircle } from 'react-icons/fa'
import { Link, NavLink } from 'react-router-dom';
import { RootContext } from '../../store/context/rootContext';

export default function Header() {
    const { authValue } = useContext(RootContext);
    const [loggedIn, setLoggedIn] = useState(false);

    useEffect(() => {
        if (authValue.user) {
            setLoggedIn(true);
        } else {
            setLoggedIn(false);
        }
    }, [authValue.user])

    const getStyle = (isActive) => {
        return {
            color: isActive ? "#f1c78d" : "#f7fbfd",
        };
    }

    const getMobileStyle = (isActive) => {
        return {
            color: isActive ? "#7f2912" : "#495057"
        }
    }

    return (
        <nav className="navbar fixed-top navbar-expand-lg navbar-light" style={{ background: "#7f2912" }} >
            <div className="container-fluid">
                <Link className="navbar-brand" to="/" style={{ color: "#effbff" }}>
                    {/* <FaHome size='2rem' className='mx-2' /> */}
                    <h1 style={{ fontSize: "1.5rem", margin: "0px" }}>
                        <img src='https://firebasestorage.googleapis.com/v0/b/samudragarh-all.appspot.com/o/images%2Fdashboard%2Flogo.png?alt=media&token=0941f992-8d94-450c-95e2-0b3cba9a3083' className='mx-2' width={30} height={30} alt='logo' />
                        Kalna All
                    </h1>
                </Link>

                <div className="collapse d-sm-inline ">
                    <ul className="d-flex flex-row navbar-nav justify-content-between" >
                        <li className="nav-item mx-2">
                            <NavLink className="nav-link" style={({ isActive }) => getStyle(isActive)} aria-current="page" to="/">
                                <FaHome /> Home
                            </NavLink>
                        </li>

                        <li className="nav-item mx-2">
                            <NavLink className="nav-link" style={({ isActive }) => getStyle(isActive)} to="/contact">
                                <FaPhoneAlt /> Contact
                            </NavLink>
                        </li>
                        <li className="nav-item mx-2">
                            {loggedIn ? <NavLink className="nav-link" style={({ isActive }) => getStyle(isActive)} to={authValue.userOwnedData?.url}>
                                <FaUser /> {authValue?.user?.user?.email}
                            </NavLink>
                                :
                                <NavLink className="nav-link" style={({ isActive }) => getStyle(isActive)} to="/login">
                                    <FaSignInAlt /> Login
                                </NavLink>}
                        </li>
                    </ul>
                </div>
                <div className='d-sm-none'>
                    {loggedIn ? <NavLink className="nav-link" style={({ isActive }) => getStyle(isActive)} to={authValue.userOwnedData?.url}>
                        <FaUserCircle size={"1.5rem"} />
                    </NavLink>
                        :
                        <NavLink className="nav-link" style={({ isActive }) => getStyle(isActive)} to="/login">
                            <FaSignInAlt size={"1.5rem"} />
                        </NavLink>}

                </div>

                {/* mobile screen */}
                <div className='row row-col-4 w-100 position-fixed bottom-0  bg-white border text-center d-sm-none'>

                    <div className='col p-1 '>
                        <NavLink to="/" style={({ isActive }) => getMobileStyle(isActive)}><FaHome /><br />Home</NavLink>
                    </div>

                    <div className="col border-3 border-start p-1">
                        <NavLink to="/contact" style={({ isActive }) => getMobileStyle(isActive)}><FaPhoneAlt /><br />contact</NavLink>
                    </div>
                </div>
            </div>
        </nav >
    )
}
